import MY_CONFIG from "@/constants";
import { ShieldCheck, Mail, Globe } from "lucide-react";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12">

        {/* Header */}
        <div className="bg-white rounded-3xl border shadow-sm p-8 mb-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 rounded-2xl bg-blue-600 text-white flex items-center justify-center">
              <ShieldCheck size={28} />
            </div>

            <div>
              <h1 className="text-3xl font-bold">
                Privacy Policy
              </h1>

              <p className="text-gray-500">
                Last Updated: June 2026
              </p>
            </div>
          </div>

          <p className="text-gray-700 leading-relaxed">
            Vehidhi respects your privacy. This Privacy Policy explains how
            our application handles information when you use our services.
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-3xl border shadow-sm p-8 space-y-8">

          <section>
            <h2 className="text-xl font-bold mb-3">
              Information We Collect
            </h2>

            <p className="text-gray-700 leading-relaxed">
              Vehidhi does not collect, store, sell, or share personal
              information. The application does not require users to create
              an account, sign in, or provide personal details.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">
              How the App Works
            </h2>

            <p className="text-gray-700 leading-relaxed">
              Vehidhi provides convenient access to publicly available
              announcements, tenders, bids, job opportunities, rentals,
              notices, and other official publications from third-party
              organizations and public sources.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">
              Saved Announcements
            </h2>

            <p className="text-gray-700 leading-relaxed">
              Users may save announcement links for later viewing. Saved
              announcements are stored locally on the user's device and are
              not transmitted to or stored on our servers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">
              External Websites
            </h2>

            <p className="text-gray-700 leading-relaxed">
              Announcement details are displayed directly from their original
              source websites using an in-app browser (web view). These
              websites are operated by third parties and may have their own
              privacy policies and data collection practices. Vehidhi is not
              responsible for the content or privacy practices of external
              websites.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">
              Analytics & Tracking
            </h2>

            <p className="text-gray-700 leading-relaxed">
              Vehidhi does not use advertising trackers and does not collect
              personal information for analytics, profiling, or marketing
              purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">
              Children's Privacy
            </h2>

            <p className="text-gray-700 leading-relaxed">
              Vehidhi does not knowingly collect personal information from
              children or any other users.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">
              Changes to This Policy
            </h2>

            <p className="text-gray-700 leading-relaxed">
              We may update this Privacy Policy from time to time. Any
              updates will be published on this page with a revised
              effective date.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-4">
              Contact Us
            </h2>

            <div className="space-y-3">

              <a
                href={`mailto:${MY_CONFIG.EMAIL}`}
                className="flex items-center gap-3 text-blue-600 hover:underline"
              >
                <Mail size={18} />
                {MY_CONFIG.EMAIL}
              </a>
{/* 
              <a
                href={MY_CONFIG.WEBSITE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-blue-600 hover:underline"
              >
                <Globe size={18} />
                {MY_CONFIG.WEBSITE_URL}
              </a> */}

            </div>
          </section>

        </div>

        {/* Footer */}
        <div className="text-center text-sm text-gray-500 mt-8">
          © {new Date().getFullYear()} {MY_CONFIG.APP_NAME}. All Rights Reserved.
        </div>
      </div>
    </div>
  );
}